<template>
  <div class="xero-export">
    <el-tooltip
      class="item"
      effect="dark"
      placement="top"
    >
      <el-button
        type="primary"
        size="mini"
        @click="export_all"
      >
        Export all to Xero
      </el-button>
      <template slot="content">
        <div
          v-html="`Accounts<br>
                      Invoices<br>
                      Invoiced POs (bills)<br>
                      Payments Received<br>
                      Credit notes<br>
                      Bank Account must be set in organization details or in Xero`"
        />
      </template>
    </el-tooltip>
    <el-form
      inline
      style="margin-left: 5px;"
    >
      <el-form-item label="From">
        <el-date-picker
          v-model="from_date"
          type="date"
          placeholder="Start date"
          size="mini"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
        />
      </el-form-item>

      <el-form-item label="To">
        <el-date-picker
          v-model="to_date"
          type="date"
          placeholder="End date"
          size="mini"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Request } from '../../utilities/Request';
import {set_default_input} from '../../utilities/DefaultInput';

export default {
  name: 'XeroExport',
  data(){
    return{
      from_date: '',
      to_date: ''
    };
  },
  mounted() {
    this.set_default_input();
  },
  methods: {
    set_default_input,
    async export_all() {
      this.$root.$emit('connect-xero-cable');
      try {
        this.$root.loading = false;
        const res = await Request.post(this, '/api/xero/export_all',null,
          { from_date: this.from_date, to_date: this.to_date });
        this.$message.success(res.data.message || 'Export completed');
        this.$emit('export-completed');
      } catch (err) {
        // this.$message.error('Export failed: ' + err.message);
        console.log('Export failed');
      }
    }
  }
};
</script>

